import styled from "@emotion/styled";
import isBrowser from "@/utils/isBrowser";

export default function LetTalkButton() {
  return (
    <a
      href="https://calendly.com/moebelleumbeau/first-consultation"
      target="_blank"
      rel="noreferrer"
    >
      <Button
        src={
          isBrowser() && location.href.indexOf("/en") > 0
            ? "/images/lettalk_en.png"
            : "/images/lettalk_de.png"
        }
        alt="Let Talk"
      />
    </a>
  );
}

const Button = styled.img`
  cursor: pointer;
  &:hover {
    transform: rotate(10deg);
  }
  ${({ theme }) => theme.breakpoints.down("lg")} {
    margin-top: 40px;
    margin-right: 50px;
    float: right;
  }

  ${({ theme }) => theme.breakpoints.up("lg")} {
    position: absolute;
    bottom: 36px;
    right: 0px;
  }
`;
